<script>
import BaseView from "@/views/BaseView.vue";
import OmniTable from "@/components/OmniTable.vue";
import PageHeader from "@/components/PageHeader.vue";
import CustomersSearchForm from "@/views/companies/customers/CustomersSearchForm.vue";
import { mapState } from "pinia";
import { useAppStore } from "@/store/app.store";
import CreateNewCompanyButton from "@/components/controls/CreateNewCompanyButton.vue";
import EditCompanyButton from "@/components/controls/EditCompanyButton.vue";

export default {
  name: "CustomersPage",
  components: { EditCompanyButton, CreateNewCompanyButton, CustomersSearchForm, PageHeader, OmniTable },
  mixins: [BaseView],
  data() {
    return {
      perm: "customers",
      headers: [
        { title: this.$t("general.name"), key: "name" },
        { title: this.$t("company.fmcsa"), key: "number" },
        { title: this.$t("company.physical_address"), key: "address" },
        { title: this.$t("company.billing_address"), key: "billingAddress" },
        {
          title: "",
          key: "actions",
          align: "end",
          width: 58,
          sortable: false,
        },
      ],
      filter: {},
      data: { items: [] },
      loading: false,
    };
  },
  computed: {
    ...mapState(useAppStore, ["mobile"]),
  },
  async created() {
    this.setTitle(this.$t("company.customers"));
    await this.refresh();
  },
  methods: {
    async refresh() {
      this.loading = true;
      const filter = { ...this.filter, ...this.params };

      try {
        const resp = await this.$api.company.findCustomers(filter);
        this.data = resp.data;
      } catch (e) {
        console.error("Error load customers list: ", e);
      }

      this.loading = false;
    },
    async search(params) {
      this.params.page = 1;
      this.filter = params;

      await this.refresh();
    },
  },
};
</script>

<template>
  <v-container :fluid="true" class="pt-6 pb-10 pl-6 pr-6 height-100">
    <page-header :header="$t('company.customers')">
      <template #suffix>
        <create-new-company-button :to="{ name: 'customer-edit', params: { id: 'new' } }" />
      </template>
    </page-header>
    <customers-search-form @search="search" />

    <omni-table
      id="customers"
      :footer-props="{ 'items-per-page-options': pagination.itemsPerPage }"
      :headers="headers"
      :items="data.items"
      :items-length="data.total || 0"
      :items-per-page="params.pageSize"
      :loading="loading"
      :mobile-breakpoint="0"
      :page="params.page"
      :show-all-option="false"
      @update:page="updatePage"
      @update:items-per-page="updatePageSize"
    >
      <template #[`item.name`]="{ item }">
        <div>{{ item.name }}</div>
        <div class="caption">{{ item.branchName }}</div>
      </template>
      <template #[`item.number`]="{ item }"> {{ item.fmcsaType }} {{ item.fmcsaNumber }}</template>
      <template #[`item.address`]="{ item }">
        {{ item.addressLine }}, {{ item.addressCity }}, {{ item.addressZipCode }},
        {{ item.addressState }}
      </template>
      <template #[`item.billingAddress`]="{ item }">
        {{ item.billingAddressLine }}, {{ item.billingAddressCity }}, {{ item.billingAddressZipCode }},
        {{ item.billingAddressState }}
      </template>
      <template #[`item.actions`]="{ item }">
        <edit-company-button :id="item.id" :to="{ name: 'customer-edit', params: { id: item.id } }" />
      </template>
    </omni-table>
  </v-container>
</template>
